import styled from 'styled-components';

const RedBackgroundText = styled.div`
  font-size: 12px;
  width: 80%;
  margin: auto;
  padding: 16px;
  background: var(--error-100);
  border: 1px solid var(--error-900);
  text-align: center;
  font-weight: 500;
`;
export default RedBackgroundText;
